import React from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import { convertTimestringToFormat } from 'helpers/timeFormat';

import { TR, TD } from 'zignal-landscape/lib/Table';

const ZccInstallationRow = ({
  styles,
  timezone,
  installation = {}
}) => {
  const { id, account, name, version, lastPing } = installation;
  const format = 'M/D/YY';
  const lastPingFormatted = convertTimestringToFormat(lastPing, format, timezone, '--');

  return (
    <TR>
      <TD>
        <div className={styles.ellipsis}>{account}</div>
      </TD>
      <TD>
        <div className={styles.ellipsis}>{name}</div>
      </TD>
      <TD>{id}</TD>
      <TD>{version}</TD>
      <TD>{lastPingFormatted}</TD>
    </TR>
  );
};

ZccInstallationRow.propTypes = {
  styles: PropTypes.object,
  key: PropTypes.string,
  timezone: PropTypes.string,
  installation: PropTypes.object,
};

export default themeable(ZccInstallationRow);
